import styled from "@emotion/styled";
import {
  Icon,
  Theme,
  TIcons,
  Typography,
  useTheme,
} from "@yuno/design-system-web";

interface SwitchPlatformButton {
  icon: TIcons;
  text: string;
  active: boolean;
  onClick: () => void;
}

const Switch = styled.div<{ theme?: Theme }>`
  z-index: 10000;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.palette.neutral.white[0]};
  padding: 4px 6px;
  border-radius: 4px;
  & p.MuiTypography-root {
    ${({ theme }) => theme.typography.small.regular};
    background: ${({ theme }) => theme.palette.neutral.white[0]};
    color: ${({ theme }) => theme.palette.grey[5]};
    margin-left: 8px;
  }
  & svg.icon {
    transition: fill 0.2s ease-in-out;
  }
`;

export const SwitchPlatformButton = ({
  icon,
  text,
  active,
  onClick,
}: SwitchPlatformButton) => {
  const { palette }: Theme = useTheme();

  const activeColor = active ? palette.vivid.brand : palette.grey[5];

  return (
    <Switch onClick={onClick}>
      <Icon
        className="icon"
        name={icon}
        size="16px"
        weight={active ? "fill" : "regular"}
        color={activeColor}
      />
      <Typography>{text}</Typography>
    </Switch>
  );
};
